import { request as sonataRequest } from 'sonata-react-components';

import type { InsertionOrderWithExtraData, PaginationResult } from 'sonata-static-storage/lib/common/common.types';
import type { InsertionOrderFlight } from 'sonata-static-storage/lib/schemas/multiFlight/insertionOrderFlight.schema';

/** Lean GET of one insertion order: only `_id` and its flights. */
export function getInsertionOrderFlights(
  userId: string,
  insertionOrderId: string
): Promise<{ _id: string; flights?: InsertionOrderFlight[] }> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}multiflight/insertionOrder/${userId}/${insertionOrderId}`,
    { method: 'GET', params: new URLSearchParams({ fields: 'flights' }) }
  );
}

export async function getInsertionOrders(
  userId: string,
  params: URLSearchParams
): Promise<PaginationResult<InsertionOrderWithExtraData>> {
  return sonataRequest.makeRequest(`${taptap.config.backendUrlBase}multiflight/insertionOrder/${userId}`, {
    method: 'GET',
    params
  });
}
